$(document).ready(function(){

    var elem = $('#gallery'),
        item = '';

    var imageDialog = new SimpleDialog(elem.get(0)),
        videoDialog = elem.find('.video-player').data('videoId') ? new YoutubeDialog(elem.get(0)) : '';

    var nextButton = elem.find('.next'),
        prevButton = elem.find('.prev');

    $('.gallery-link').each(function(){
        $(this).on('click', function(e){
            if(elem.is('.simple-dialog')) {
                e.preventDefault();
                elem.find('[data-item]').each(function(index, el) { $(el).removeClass('show'); });
                item = parseInt($(this).data('item'));
                elem.find('[data-item="' + item + '"]').addClass('show');
                changeDialogType(item);
            }
        });
    });

    $(nextButton).on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if(elem.find('[data-item="' + (item + 1) + '"]').length) {
            elem.find('[data-item="' + item + '"]').removeClass('show');
            elem.find('[data-item="' + (item + 1) + '"]').addClass('show');
            item += 1;
            changeDialogType(item);
        }
    });

    $(prevButton).on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if(elem.find('[data-item="' + (item - 1) + '"]').length) {
            elem.find('[data-item="' + item + '"]').removeClass('show');
            elem.find('[data-item="' + (item - 1) + '"]').addClass('show');
            item -= 1;
            changeDialogType(item);
        }
    });

    $(document).on('keydown', function(e) {
        if (e.keyCode == 39 && elem.find('[data-item="' + (item + 1) + '"]').length) {
            elem.find('[data-item="' + item + '"]').removeClass('show');
            elem.find('[data-item="' + (item + 1) + '"]').addClass('show');
            item += 1;
            changeDialogType(item);
        } else if(e.keyCode == 37 && elem.find('[data-item="' + (item - 1) + '"]').length) {
            elem.find('[data-item="' + item + '"]').removeClass('show');
            elem.find('[data-item="' + (item - 1) + '"]').addClass('show');
            item -= 1;
            changeDialogType(item);
        }
    });

    function changeDialogType(item) {
        if(elem.find('[data-item="' + item + '"]').hasClass('video-container')) {
            imageDialog.hide();
            if(videoDialog) videoDialog.show();
        } else {
            if(videoDialog) videoDialog.hide();
            imageDialog.show();
        }
        elem.find('.count').text(item);
    }
});

